import { Link } from 'gatsby'
import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { navigate } from "@reach/router"
import { ListPropertyBaseURL } from "../../common/site/utils"

import './SellPlanning.scss'

const SellPlanning = (props) => {

    var backurl = "/property/for-sale/";

    function backPage() {
        if (window.history?.state?.key) {
            window.history.back()
        } else {
            navigate(backurl)
        }
    }

    return (
        <section className='sell-planning'>
            <Container>
                <Row>
                    <Col>
                        <div className='plan-wrap d-md-flex justify-content-between'>
                            {props.status === "off market" ?
                                <p>&nbsp;</p>
                                :
                                <a href={'javascript:void(0)'} onClick={(e) => backPage()} className='back-btn'>Back to Search Listings</a>
                            }


                            <div className='d-none d-md-block'>
                                <p>Need to Sell or Let your property first? <Link to={ListPropertyBaseURL} className='property-list'>List your property</Link> with us</p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>

    )
}

export default SellPlanning